export default "__VITE_ASSET__BvojAfOn__"